export default {
  text: 'Ganas <highlight>{{value}} puntos</highlight> con este pedido',
};
